import { Navigate, createBrowserRouter } from 'react-router-dom'
import App from '../App'
import { RedirectIfSignedIn, RequireAuth } from './RouteGuards'
import { paths } from './routes'
import { LoginScreen } from '../screens/Login/LoginScreen'
import { HomeScreen } from '../screens/Home/HomeScreen'
import { PalletsScreen } from '../screens/Pallets/PalletsScreen'
import { PalletScreen } from '../screens/Pallet/PalletScreen'
import { ManualScreen } from '../screens/Manual/ManualScreen'
import { BasketScreen } from '../screens/Basket/BasketScreen'
import { AssignScreen } from '../screens/Assign/AssignScreen'
import { AssignResultScreen } from '../screens/Assign/AssignResultScreen'
import { QueueScreen } from '../screens/Queue/QueueScreen'
import { SettingsScreen } from '../screens/Settings/SettingsScreen'

export const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        path: paths.login,
        element: (
          <RedirectIfSignedIn>
            <LoginScreen />
          </RedirectIfSignedIn>
        ),
      },
      { index: true, element: <RequireAuth><HomeScreen /></RequireAuth> },
      { path: paths.pallets, element: <RequireAuth><PalletsScreen /></RequireAuth> },
      { path: paths.pallet, element: <RequireAuth><PalletScreen /></RequireAuth> },
      { path: paths.manual, element: <RequireAuth><ManualScreen /></RequireAuth> },
      { path: paths.basket, element: <RequireAuth><BasketScreen /></RequireAuth> },
      { path: paths.assign, element: <RequireAuth><AssignScreen /></RequireAuth> },
      { path: paths.assignResult, element: <RequireAuth><AssignResultScreen /></RequireAuth> },
      { path: paths.queue, element: <RequireAuth><QueueScreen /></RequireAuth> },
      { path: paths.settings, element: <RequireAuth><SettingsScreen /></RequireAuth> },
      { path: '*', element: <Navigate to={paths.home} replace /> },
    ],
  },
])
